<template>
  <div class="app-container">
    <header class="app-header">
      <div class="header-top">
        <div class="header-title">Отчёты из международных баз данных: {{ person?.name }}</div>
      </div>
      <div class="upload-area" id="upload-area">

         <div class="report-tabs" id="report-tabs">
          <div v-for="(s,k) in sources" :class="'tab-btn'+(k===source?' active':'')" @click="source=k">
            <i v-if="data[k]?.layout?.id" class="bi bi-check-circle-fill text-success" title="Есть настройки"></i>
            <i v-else class="bi bi-x-circle-fill text-danger" title="Нет настроек"></i>
            {{ s }} ({{ data[k]?.sources.length }})
          </div>
           <button class="btn btn-sm ms-3 btn-outline-dark" @click="$modal('show', 'add_report');">
          <span>+</span> Добавить отчёт
        </button>
        </div>


      </div>

    </header>

    <main class="app-main">
      <section class="panel">

        <div class="panel-content" id="report-content">
          <PdfFields :data="data[source]?.sources" :removeFunction="removeSource"/>
        </div>
      </section>
      <PdfPreview :data="data[source]?.sources"></PdfPreview>
      <PdfLayout :layout="data[source]?.layout"></PdfLayout>

    </main>

    <footer class="app-footer">
      <span style="color:#555; font-size:14px;">
  {{ hasChanges ? 'Есть изменения' : 'Изменений нет' }}
</span>
      <span id="selection-counter" style="color:#555; font-size:14px;">Выбрано: {{ calcCount() }} </span>
      <button class="btn btn-sm btn-primary" :disabled="!hasChanges" @click="saveLayout">Сохранить разметку</button>
    </footer>

    <modal modal_id="add_report">
      <template v-slot:header>
        <h2>
          Добавить отчёт
        </h2>
      </template>

      <template v-slot:body>
        <div :class="'mb-4'+(pdf_load?' is-loading':'')">
          <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
            <template v-for="(name, key) in sources">
              <input type="radio" class="btn-check" name="source" :id="'source'+key" autocomplete="off" :value="key"
                     v-model="source">
              <label class="btn btn-outline-dark" :for="'source'+key">{{ name }}</label>
            </template>

          </div>
          <div
              :class="['dropzone-area', dragging ? 'dropzone-over' : '']"
              drag-over="handleDragOver"
              @dragenter="dragging=true"
              @dragleave="dragging=false">

            <div class="dropzone-text">
              <span class="dropzone-title">Перетащите файл сюда или кликните для выбора</span>
              <span class="dropzone-info">PDF file</span>
            </div>
            <input type="file" ref="pdf_file" accept="application/pdf" @change="onFileChange">
          </div>
        </div>
        <div class="dropzone-preview">
          {{ pdf.name }}
          <button @click="removeFile" class="btn btn-sm btn-outline-dark" v-if="pdf">Загрузить другой</button>
        </div>
      </template>
      <template v-slot:footer>
        <div :class="'d-flex' + (pdf_load?' is-loading no-ico':'')">
          <button class="btn btn-sm btn-secondary" @click="$modal('hide', 'add_report');">Отмена</button>
          <button class="btn btn-sm btn-dark" @click="parserPdf">Обработать файл</button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>

import {PdfApi} from "@/api/pdf";
import {ProjectApi} from "@/api/project";
import PdfFields from "@/views/projects/pdf/components/PdfFields.vue";
import PdfPreview from "@/views/projects/pdf/components/PdfPreview.vue";
import PdfLayout from "@/views/projects/pdf/components/PdfLayout.vue";

export default {
  name: 'PdfDBParser',
  components: {PdfLayout, PdfPreview, PdfFields},
  data() {
    return {
      data: {},
      pdf: '',
      dragging: false,
      source: "",
      sources: [],
      person: null,
      project: null,
      pdf_load: false,
      dump_data: null
    }
  },
  computed: {
    hasChanges() {
      if (!this.dump_data) return false;
      return JSON.stringify(this.data) !== JSON.stringify(this.dump_data);
    }
  },
  mounted: function () {
    this.projectInfo();

    const $this = this;
    ProjectApi.get_simple(this.$route.params.id).then(response => {
      $this.project = response
    });

  },
  methods: {
    saveLayout() {
      const $this = this;
      PdfApi.save_change({data: JSON.stringify(this.data), project_id:this.project.id}).then(response => {
        $this.data = response.pdf_data;
        $this.dump_data = JSON.parse(JSON.stringify(response.pdf_data));
         $this.$notify({
            type: "success",
            text: "Данные успешно сохранены"
          })
      })
    },
    calcCount() {
      let count = 0

      if (this.data[this.source]) this.data[this.source].sources.forEach(pdf => {
        count += Object.values(pdf.json_data).filter(x => x.select).length
      })
      return count
    },
    removeSource(id) {
      const $this = this;
      PdfApi.remove(id).then(() => {
        const index = $this.data[this.source].sources.findIndex(x => x.id === id);
        $this.data[this.source].sources.splice(index, 1);
        $this.$modal('hide', 'delete_report');
      })
    },
    projectInfo() {
      const $this = this;
      PdfApi.project_info(this.$route.params.id).then(response => {
        $this.sources = response.sources;
        if (!$this.source) $this.source = Object.keys($this.sources)[0];
        $this.person = response.person;
        $this.data = response.pdf_data;
        $this.dump_data = JSON.parse(JSON.stringify(response.pdf_data));
      })
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.pdf = files[0];
    },
    removeFile() {
      this.pdf = '';
      this.$refs.pdf_file.value = "";
    },
    parserPdf() {
      const $this = this;
      this.pdf_load = true;
      let formData = new FormData()
      formData.set('file', this.pdf)
      formData.set('source', this.source)
      formData.set('person', this.person.id)
      formData.set('project_id', this.$route.params.id)
      $this.removeFile();
      PdfApi.load_pdf(formData).then(() => {
        $this.projectInfo();
        this.pdf_load = false;
        $this.$modal('hide', 'add_report');
      });
    },
  }
}

</script>

<style scoped lang="scss">
.app-container:root {
  --primary-color: #2c3e50;
  --accent-color: #3498db;
  --border-color: #dee2e6;
  --success: #28a745;
  --danger: #e74c3c;
  --warning: #f39c12;
  --bg-light: #f8f9fa;
}

.app-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.app-header {
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 15px 30px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  flex-shrink: 0;
  z-index: 20;
}

.header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-title {
  font-size: 24px;
  color: var(--primary-color);
  font-weight: 600;
}

.dropzone-over {

  border: 1px solid red !important;
}

.dropzone-area {
  margin-top: 20px;
  height: 150px;
  position: relative;
  border: 2px dashed #CBCBCB;

  &:hover {
    border: 2px dashed #2E94C4;

    .dropzone-title {
      color: #1975A0;
    }

  }
}

.dropzone-area input {
  position: absolute;
  cursor: pointer;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropzone-text {
  position: absolute;
  top: 50%;
  text-align: center;
  transform: translate(0, -50%);
  width: 100%;

  span {
    display: block;
    line-height: 1.9;
  }
}

.dropzone-title {
  font-size: 13px;
  color: #787878;
  letter-spacing: 0.4px;
}

.dropzone-info {
  font-size: 13px;
  color: #A8A8A8;
  letter-spacing: 0.4px;
}

.dropzone-button {
  position: absolute;
  top: 10px;
  right: 10px;
  display: none;
}

.dropzone-preview {
  width: 80%;
  position: relative;

  &:hover .dropzone-button {
    display: block;
  }

  img {
    display: block;
    height: auto;
    max-width: 100%;
  }

}


.upload-area {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  align-items: flex-start;
}

.file-card {
  background: #f8f9fa;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  width: 180px;
  position: relative;
}

.file-card.loaded {
  border-color: var(--success);
  background-color: #f0fff4;
}

.file-card-title {
  font-size: 11px;
  font-weight: 700;
  color: #555;
  margin-bottom: 4px;
  text-transform: uppercase;
}

.file-card-name {
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #333;
}

.btn-remove-file {
  position: absolute;
  top: 4px;
  right: 4px;
  border: none;
  background: none;
  color: #999;
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
}

.btn-parse {
  background: #bdc3c7;
  color: #fff;
  border: none;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
  cursor: not-allowed;
}

.btn-parse.active {
  background: var(--accent-color);
  cursor: pointer;
}

.app-main {
  flex-grow: 1;
  display: grid;
  grid-template-columns: 40% 40% 20%;
  gap: 15px;
  overflow: hidden;
}


.report-tabs {
  display: flex;
  gap: 4px;
  padding: 0 10px;
  border-bottom: 1px solid var(--border-color);
  flex-shrink: 0;
  top: 0;
  position: sticky;

}

.tab-btn {
  padding: 10px 20px;
  cursor: pointer;
  background: #e9ecef;
  font-size: 14px;
  color: #666;
  font-weight: 500;
  border-radius: 6px 6px 0 0;
  border: 1px solid transparent;
  border-bottom: none;
}

.tab-btn.active {
  background: #fff;
  color: var(--accent-color);
  font-weight: 700;
  margin-bottom: -1px;
  padding-bottom: 11px;
  border: 1px solid #ccc;
  border-top: 2px solid #3498db;
}

.group-input {
  width: 45px;
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 4px;
  font-size: 11px;
}


.groups-content {
  padding: 15px;
}

.group-card {
  background: #f8f9fa;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
}

.group-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.group-title {
  font-weight: 700;
  font-size: 13px;
  color: #2c3e50;
}

.btn-delete {
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  font-size: 16px;
}

.group-items-list {
  font-size: 11px;
  color: #555;
  padding-left: 10px;
  margin: 0 0 8px 0;
  border-left: 2px solid #ddd;
  max-height: 60px;
  overflow-y: auto;
}

.group-comment {
  width: 100%;
  padding: 8px;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  font-size: 12px;
  font-family: inherit;
  resize: vertical;
  min-height: 50px;
  box-sizing: border-box;
}

.app-footer {
  height: 40px;
  background: #fff;
  border-top: 1px solid var(--border-color);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 30px;
  gap: 15px;
}

.btn-save {
  background: var(--success);
  color: #fff;
  border: none;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 700;
  border-radius: 6px;
  cursor: pointer;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}


.is-loading {
  position: relative;
  pointer-events: none; /* блокируем взаимодействие с содержимым */
  user-select: none;
}

/* Размываем только содержимое, но не сам спиннер.
   Всё, что не является ::after — уходит в blur. */
.is-loading > * {
  filter: blur(4px);
  opacity: .6;
  transition: filter .2s ease, opacity .2s ease;
}

/* Оверлей со спиннером */
.is-loading:not(.no-ico)::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 10;

  /* Спиннер */
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 50 50'><circle cx='25' cy='25' r='20' fill='none' stroke='%23666' stroke-width='4' stroke-linecap='round' stroke-dasharray='31.4 31.4'><animateTransform attributeName='transform' type='rotate' from='0 25 25' to='360 25 25' dur='0.9s' repeatCount='indefinite'/></circle></svg>");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 40px 40px;

  /* Лёгкое затемнение фона под прелоадером (опционально) */
  background-color: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(1px);

  transition: opacity .2s ease;
}

/* Плавное появление/исчезновение (можно не использовать, если не нужно) */
.is-loading::after {
  animation: is-loading-fade-in .15s ease;
}

@keyframes is-loading-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
